import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-volume-2",
  "use": "icon_player-volume-2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-volume-2\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M15.54 8.45969c.9374.93764 1.4639 2.20921 1.4639 3.53501s-.5265 2.5973-1.4639 3.535m3.53-10.60001c1.8747 1.87527 2.9279 4.41836 2.9279 7.07001 0 2.6516-1.0532 5.1947-2.9279 7.07M11 4.99969l-5 4H2v6.00001h4l5 4V4.99969Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol